import React from 'react'
import take from 'lodash/take'
import orderBy from 'lodash/orderBy'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { useStyles } from './styles'
import { numberWithCommas } from '../../../../utils'
import { TAG_ICONS_COMPONENTS_MAP, CARD_TYPE_ICONS_MAP } from '../../../../constants/story'

import PatientCareIcon from '../../../Icons/tags/PatientCareIcon'

const StoriesByTagAndType = ({ data: { stories, tags } }) => {
  const classes = useStyles()
  const sortedTags = take(tags.top, 3)

  return (
    <Grid container item xs={12} alignItems='center' justifyContent='space-between' className={classes.row}>
      <Grid container alignItems='center' justifyContent='center' item xs={6}>
        <div className={classes.leftBlock}>
          <div className={classes.tags}>
            {sortedTags.map((tag, idx) => {
              const mostTag = idx === 0 && tag.usageCount > 0
              const TagIconComponent = TAG_ICONS_COMPONENTS_MAP[tag.name] || PatientCareIcon
              return (
                <div key={tag.id} className={mostTag ? classes.mostTag : classes.tag}>
                  <Typography variant='h3' component='div' className={classes.amount}>
                    {numberWithCommas(tag.usageCount)}
                  </Typography>
                  <div className={classes.icon}>
                    <TagIconComponent size={64} fillColor={mostTag ? '#FFFFFF' : '#8688A1'} />
                  </div>
                  <Typography variant='h6' component='div' className={classes.name}>
                    {tag.name}
                  </Typography>
                </div>
              )
            })}
          </div>
        </div>
      </Grid>
      <Grid container alignItems='center' justifyContent='center' item xs={6}>
        <div className={classes.rightBlock}>
          <div className={classes.tags}>
            {orderBy(stories.byType, 'count', 'desc').map((tag, idx) => {
              const mostType = idx === 0 && tag.count > 0
              const CardTypeIconComponent = CARD_TYPE_ICONS_MAP[tag.resourceType]
              return (
                <div key={tag.resourceType} className={mostType ? classes.mostTag : classes.tag}>
                  <Typography variant='h3' component='div' className={classes.amount}>
                    {numberWithCommas(tag.count)}
                  </Typography>
                  <div className={classes.icon}>
                    <CardTypeIconComponent size={64} fillColor={mostType ? '#FFFFFF' : '#8688A1'} />
                  </div>
                  <Typography variant='h6' component='div' className={classes.name}>
                    {tag.resourceType}
                  </Typography>
                </div>
              )
            })}
          </div>
        </div>
      </Grid>
    </Grid>
  )
}

export default StoriesByTagAndType
